"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BI = void 0;
/*
 * @Author: your name
 * @Date: 2021-11-03 15:47:24
 * @LastEditTime: 2021-12-30 09:30:41
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \sdk\bi-sdk\src\render\index.ts
 */
var Pie_1 = __importDefault(require("./Pie"));
var Line_1 = __importDefault(require("./Line"));
var Bar_1 = __importDefault(require("./Bar"));
var Gauge_1 = __importDefault(require("./Gauge"));
var Heatmap_1 = __importDefault(require("./Heatmap"));
var SanKey_1 = __importDefault(require("./SanKey"));
var Radar_1 = __importDefault(require("./Radar"));
var Scatter_1 = __importDefault(require("./Scatter"));
exports.BI = { Pie: Pie_1.default, Line: Line_1.default, Bar: Bar_1.default, Gauge: Gauge_1.default, Heatmap: Heatmap_1.default, SanKey: SanKey_1.default, Radar: Radar_1.default, Scatter: Scatter_1.default };
//# sourceMappingURL=index.js.map